import {useAnyFiltersApplied} from '../../hooks/use-any-applied-filters.js'
import {Box, BoxProps, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {IconType} from 'react-icons/lib'

export interface EmptyTableStateProps extends BoxProps {
  title: string
  description?: string
  icon?: IconType
}

export function EmptyTableState({title, description, icon, ...props}: EmptyTableStateProps) {
  const {t} = useTranslate('common')
  const anyFiltersApplied = useAnyFiltersApplied()

  return (
    <Box display="flex" justifyContent="center" width="100%" alignItems="center" height="100%" {...props}>
      <Box display="flex" flexDirection="column" gap="4" alignItems="center">
        {icon?.({size: '32', opacity: '0.5'})}

        <Box display="flex" flexDirection="column" gap="1" alignItems="center">
          <Text fontSize="md" fontWeight="semibold">
            {title}
          </Text>
          {description && (
            <Text fontSize="sm" color="fg.muted">
              {!anyFiltersApplied && description}
              {anyFiltersApplied && t('no_results_for_applied_filters')}
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  )
}
